export const CHARS = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
export const BATCH_SIZE = CHARS.length;
export const CANVAS_WIDTH = 50;
export const CANVAS_HEIGHT = 50;
